__turbopack_context__.v({
  "newsEmpty": "dTFtWa_newsEmpty",
  "newsEmptyText": "dTFtWa_newsEmptyText",
  "newsEmptyTitle": "dTFtWa_newsEmptyTitle",
  "newsPosted": "dTFtWa_newsPosted",
  "newsPostedWash": "dTFtWa_newsPostedWash",
  "postAction": "dTFtWa_postAction",
  "postTip": "dTFtWa_postTip",
  "postTipDismiss": "dTFtWa_postTipDismiss",
  "postTipText": "dTFtWa_postTipText",
  "postTrigger": "dTFtWa_postTrigger",
});
